<cass-core-toolbar></cass-core-toolbar>
<div class='page-container'>
	<div class="page-grid">
		<div class="order-panels">
			<mat-card class="branding--title-card">
				<mat-card-content class="branding--title-card-content-box">
					<div class="order-title-card">
						<h1>{{ order.orderHeader.id ? "" : "New "}} {{ "ORDER_BASKET.PAGE_TITLE_WORD_ORDER" | translate }} {{ order.orderHeader.id }}</h1>
						<div class="customer-heading" *ngIf="showCustomerAndAgency">
							<mat-icon>person</mat-icon>
							{{ order.orderHeader.advertiserName }}
							<ng-container *ngIf="order.orderHeader.otherPayerName as agencyName">
								&bull; {{ agencyName }}
							</ng-container>
						</div>
						<div *ngIf="showExternalPlanId" class="marathon-id">
							{{ 'ORDER_BASKET.EXTERNAL_PLANNER.EXTERNAL_PLAN_NO' | translate }}
							<span *ngIf="isOrderExported; else notExported">{{order.orderHeader.externalPlanId}}&nbsp;{{'ORDER_BASKET.EXTERNAL_PLANNER.MESSAGES.ORDER_BASKET_EXPORTED' | translate}}</span>
							<ng-template #notExported>{{getExternalPlanId}}
								<a class="change-link" (click)="change()">({{ "ORDER_BASKET.EXTERNAL_PLANNER.ACTION_BUTTON_LABELS.CHANGE" | translate }})</a>
								&nbsp;<span>{{ 'ORDER_BASKET.EXTERNAL_PLANNER.MESSAGES.SAVE_TO_EXPORT' | translate }}</span>
							</ng-template>
						</div>
						<div class="flex-spacer"></div>
						<mat-chip-set class="status-chip-list">
							<mat-basic-chip *ngIf="orderStatusVM.isNew" class="branding--order-status-draft">{{ "ORDER_BASKET.STATUS.NEW" | translate }}</mat-basic-chip>
							<mat-basic-chip *ngIf="orderStatusVM.draft" class="branding--order-status-draft">{{ "ORDER_BASKET.STATUS.DRAFT" | translate }}</mat-basic-chip>
							<mat-basic-chip *ngIf="orderStatusVM.started" class="branding--order-status-started">{{ "ORDER_BASKET.STATUS.STARTED" | translate }}</mat-basic-chip>
							<mat-basic-chip *ngIf="orderStatusVM.finished" class="branding--order-status-finished">{{ "ORDER_BASKET.STATUS.FINISHED" | translate }}</mat-basic-chip>
							<mat-basic-chip *ngIf="orderStatusVM.approvalPendingAdCount > 0" class="branding--order-status-approval-pending">{{ ("ORDER_BASKET.STATUS.APPROVAL_PENDING" | translate) + " x" + orderStatusVM.approvalPendingAdCount }}</mat-basic-chip>
							<mat-basic-chip *ngIf="orderStatusVM.reservedAdCount > 0" class="branding--order-status-reserved">{{ ("ORDER_BASKET.STATUS.RESERVED" | translate) + " x" + orderStatusVM.reservedAdCount }}</mat-basic-chip>
							<mat-basic-chip *ngIf="orderStatusVM.confirmedAdCount > 0" class="branding--order-status-confirmed">{{ ("ORDER_BASKET.STATUS.CONFIRMED" | translate) + " x" + orderStatusVM.confirmedAdCount }}</mat-basic-chip>
							<mat-basic-chip *ngIf="orderStatusVM.rejectedAdCount > 0" class="branding--order-status-rejected">{{ ("ORDER_BASKET.STATUS.REJECTED" | translate) + " x" + orderStatusVM.rejectedAdCount }}</mat-basic-chip>
							<mat-basic-chip *ngIf="orderStatusVM.waitingMaterial" class="branding--order-status-waiting-material">{{ "ORDER_BASKET.STATUS.WAITING_MATERIAL" | translate }}</mat-basic-chip>
							<mat-basic-chip *ngIf="orderStatusVM.cancelled" class="branding--order-status-cancelled">{{ "ORDER_BASKET.STATUS.CANCELLED" | translate }}</mat-basic-chip>
						</mat-chip-set>
					</div>
				</mat-card-content>
			</mat-card>

			<mat-card class="branding--section-card">
				<mat-card-content class="branding--section-card-content-box">
					<div class="summary-grid">
						<div class="fields-container" [formGroup]="form">
							<div class="fields-container-row">
								<div class='field growing-field'>
									<div *ngIf="!changeCampaignName" (click)="updateField('campaignName', false);">
										<div class='data-panel-field-label mandatory-field-indicator'>{{ "ORDER_BASKET.FIELDS.CAMPAIGN_NAME" | translate }}</div>
										<div class='data-panel-field-value click-to-edit'>{{ order.orderHeader.campaignName ?? ("ORDER_BASKET.FIELDS.EMPTY_FIELD_PLACEHOLDER" | translate) }}</div>
									</div>
									<mat-form-field *ngIf="changeCampaignName" floatLabel="always" subscriptSizing="dynamic">
										<mat-label>{{ "ORDER_BASKET.FIELDS.CAMPAIGN_NAME" | translate }}</mat-label>
										<input matInput formControlName="campaignName" placeholder="{{'ORDER_BASKET.FIELDS.EMPTY_FIELD_PLACEHOLDER' | translate }}" (blur)="updateField('campaignName', true)" (keyup.enter)="updateField('campaignName', true)" autofocus />
										<mat-error [cassErrorForFormControl]="campaignName"></mat-error>
									</mat-form-field>
								</div>
							</div>
							<div class="fields-container-row" *ngIf="agencyContact">
								<div class="field">
									<div class="data-panel-field-label">{{ "ORDER_BASKET.FIELDS.AGENCY_CONTACT_FIRSTNAME" | translate }}</div>
									<div class="data-panel-field-value">{{ agencyContact.firstName }}</div>
								</div>
								<div class="field">
									<div class="data-panel-field-label">{{ "ORDER_BASKET.FIELDS.AGENCY_CONTACT_LASTNAME" | translate }}</div>
									<div class="data-panel-field-value">{{ agencyContact.lastName }}</div>
								</div>
								<div class="field">
									<div class="data-panel-field-label">{{ "ORDER_BASKET.FIELDS.AGENCY_CONTACT_EMAIL" | translate }}</div>
									<div class="data-panel-field-value">{{ agencyContact.email }}</div>
								</div>
							</div>

							<div class="fields-container-row">
								<div class="field">
									<div *ngIf="!changeMaterialCompany" (click)="restriction.canChangeMaterialAgency && updateField('materialCompany', false);">
										<div class='data-panel-field-label'>{{ "ORDER_BASKET.FIELDS.COMPANY" | translate }}</div>
										<div class='data-panel-field-value' [ngClass]="{ 'click-to-edit': restriction.canChangeMaterialAgency }">{{ order.materialAgencyName ?? ("ORDER_BASKET.FIELDS.EMPTY_FIELD_PLACEHOLDER" | translate) }}</div>
									</div>
									<mat-form-field *ngIf="changeMaterialCompany" floatLabel="always" subscriptSizing="dynamic">
										<mat-label>{{ "ORDER_BASKET.FIELDS.COMPANY" | translate }}</mat-label>
										<input matInput formControlName="materialCompany" placeholder="{{'ORDER_BASKET.FIELDS.EMPTY_FIELD_PLACEHOLDER' | translate }}" (blur)="updateField('materialCompany', true)" (keyup.enter)="updateField('materialCompany', true)" autofocus />
										<mat-error [cassErrorForFormControl]="materialCompany"></mat-error>
									</mat-form-field>
								</div>
								<div class="field">
									<div *ngIf="!changeMaterialContactFirstName" (click)="updateField('materialContactFirstName', false);">
										<div class='data-panel-field-label'>{{ "ORDER_BASKET.FIELDS.CONTACT_FIRSTNAME" | translate }}</div>
										<div class='data-panel-field-value click-to-edit'>{{ order.materialContactFirstName ?? ("ORDER_BASKET.FIELDS.EMPTY_FIELD_PLACEHOLDER" | translate) }}</div>
									</div>
									<mat-form-field *ngIf="changeMaterialContactFirstName" floatLabel="always" subscriptSizing="dynamic">
										<mat-label>{{ "ORDER_BASKET.FIELDS.CONTACT_FIRSTNAME" | translate }}</mat-label>
										<input matInput formControlName="materialContactFirstName" placeholder="{{'ORDER_BASKET.FIELDS.EMPTY_FIELD_PLACEHOLDER' | translate }}" (blur)="updateField('materialContactFirstName', true)" (keyup.enter)="updateField('materialContactFirstName', true)" autofocus />
										<mat-error [cassErrorForFormControl]="materialContactFirstName"></mat-error>
									</mat-form-field>
								</div>
								<div class="field">
									<div *ngIf="!changeMaterialContactLastName" (click)="updateField('materialContactLastName',false)">
										<div class='data-panel-field-label'>{{ "ORDER_BASKET.FIELDS.CONTACT_LASTNAME" | translate }}</div>
										<div class='data-panel-field-value click-to-edit'>{{ order.materialContactLastName ?? ("ORDER_BASKET.FIELDS.EMPTY_FIELD_PLACEHOLDER" | translate) }}</div>
									</div>
									<mat-form-field *ngIf="changeMaterialContactLastName" floatLabel="always" subscriptSizing="dynamic">
										<mat-label>{{ "ORDER_BASKET.FIELDS.CONTACT_LASTNAME" | translate }}</mat-label>
										<input matInput formControlName="materialContactLastName" placeholder="{{'ORDER_BASKET.FIELDS.EMPTY_FIELD_PLACEHOLDER' | translate }}" (blur)="updateField('materialContactLastName', true)" (keyup.enter)="updateField('materialContactLastName', true)" autofocus />
										<mat-error [cassErrorForFormControl]="materialContactLastName"></mat-error>
									</mat-form-field>
								</div>
								<div class="field">
									<div *ngIf="!changeMaterialContactPhone" (click)="updateField('materialContactPhone',false)">
										<div class='data-panel-field-label'>{{ "ORDER_BASKET.FIELDS.PHONE" | translate }}</div>
										<div class='data-panel-field-value click-to-edit'>{{ order.materialContactPhone ?? ("ORDER_BASKET.FIELDS.EMPTY_FIELD_PLACEHOLDER" | translate) }}</div>
									</div>
									<mat-form-field *ngIf="changeMaterialContactPhone" floatLabel="always" subscriptSizing="dynamic">
										<mat-label>{{ "ORDER_BASKET.FIELDS.PHONE" | translate }}</mat-label>
										<input matInput formControlName="materialContactPhone" placeholder="{{'ORDER_BASKET.FIELDS.EMPTY_FIELD_PLACEHOLDER' | translate }}" (blur)="updateField('materialContactPhone', true)" (keyup.enter)="updateField('materialContactPhone', true)" autofocus />
										<mat-error [cassErrorForFormControl]="materialContactPhone"></mat-error>
									</mat-form-field>
								</div>
								<div class="field">
									<div *ngIf="!changeMaterialContactEmail" (click)="updateField('materialContactEmail',false)">
										<div class='data-panel-field-label'>{{ "ORDER_BASKET.FIELDS.EMAIL" | translate }}</div>
										<div class='data-panel-field-value click-to-edit'>{{ order.materialContactEmail ?? ("ORDER_BASKET.FIELDS.EMPTY_FIELD_PLACEHOLDER" | translate) }}</div>
									</div>
									<mat-form-field *ngIf="changeMaterialContactEmail" floatLabel="always" subscriptSizing="dynamic">
										<mat-label>{{ "ORDER_BASKET.FIELDS.EMAIL" | translate }}</mat-label>
										<input matInput formControlName="materialContactEmail" placeholder="{{'ORDER_BASKET.FIELDS.EMPTY_FIELD_PLACEHOLDER' | translate }}" (blur)="updateField('materialContactEmail', true)" (keyup.enter)="updateField('materialContactEmail', true)" autofocus />
										<mat-error [cassErrorForFormControl]="materialContactEmail"></mat-error>
									</mat-form-field>
								</div>
							</div>
							<div class="fields-container-row">
								<div class='field'>
									<div class='data-panel-field-label'>{{ "ORDER_BASKET.FIELDS.FIRST_DATE" | translate }}</div>
									<div class='data-panel-field-value'>{{ order.orderHeader.startDate | cassDate }}</div>
								</div>
								<div class='field'>
									<div class='data-panel-field-label'>{{ "ORDER_BASKET.FIELDS.LAST_DATE" | translate }}</div>
									<div class='data-panel-field-value'>{{ order.orderHeader.endDate | cassDate }}</div>
								</div>
								<div class='field'>
									<div class='data-panel-field-label'>{{ "ORDER_BASKET.FIELDS.NEXT_DATE" | translate }}</div>
									<div class='data-panel-field-value'>{{ order.orderHeader.nextDate | cassDate }}</div>
								</div>
								<div class='field'>
									<div class='data-panel-field-label'>{{ "ORDER_BASKET.FIELDS.RUNS_BOOKED_AND_REMAINING" | translate }}</div>
									<div class='data-panel-field-value'>{{ order.orderHeader.adCount }} / {{ order.orderHeader.adCountRemaining }}</div>
								</div>
							</div>
						</div>
						<div class="deadline-warning-and-price-breakdown-container">
							<div class="confirmation-deadline-warning" *ngIf="isConfirmationDeadlineApproaching || isConfirmationDeadlinePassed" [class.confirmation-deadline-approaching]="isConfirmationDeadlineApproaching" [class.confirmation-deadline-passed]="isConfirmationDeadlinePassed">
								<ng-container *ngIf="isConfirmationDeadlineApproaching">
									<mat-icon>access_time</mat-icon>
									<span>&nbsp;{{ "ORDER_BASKET.CONFIRMATION_DEADLINE_WARNING.APPROACHING" | translate }}</span>
								</ng-container>
								<ng-container *ngIf="isConfirmationDeadlinePassed">
									<mat-icon>notifications_active</mat-icon>
									<span>&nbsp;{{ "ORDER_BASKET.CONFIRMATION_DEADLINE_WARNING.PASSED" | translate }}</span>
								</ng-container>
							</div>
							<cass-price-breakdown [currencyCode]="order.currencyCode"
												  [priceGross]="order.priceGross"
												  [discounts]="order.discountAmount"
												  [netExCommission]="order.orderHeader.priceNetExComm"
												  [commissionAmount]="order.orderHeader.commissionAmount"
												  [priceExTax]="order.orderHeader.priceNetExTax"
												  [tax]="order.orderHeader.taxAmount"
												  [priceIncTax]="order.orderHeader.priceNetIncTax"
												  [isDirect]="isDirectOrder">
							</cass-price-breakdown>
							<div class="price-summation-button-container dense-component-container">
								<button [disabled]="!(order && order.orderAdDetails && order.orderAdDetails.length > 0)"
										class="open-price-summation-button"
										mat-stroked-button
										(click)="openPriceSummationModal()">
									<mat-icon>functions</mat-icon>
								</button>
							</div>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
			<!--Order Lines-->
			<mat-card class="branding--section-card">
				<mat-card-content class="branding--section-card-content-box">
					<h2 class="branding--section-card-heading">{{ "ORDER_BASKET.ORDER_LINES_SECTION_TITLE" | translate }} ({{ order.orderAdDetails.length || 0 }})</h2>
					<div class="table-container" cassStickyTableHeader styleClass="cass-order-line-table-sticky-header" [ngStyle]="{ display: order.orderAdDetails.length ? 'block' : 'none' }">
						<table #orderLinesTable
							   mat-table
							   matSort
							   [dataSource]="orderAdDetailsDataSource"
								   multiTemplateDataRows>
								<ng-container matColumnDef="select">
									<th mat-header-cell *matHeaderCellDef>
										<mat-checkbox (change)="$event ? toggleAllRows() : null"
													  [checked]="selection.hasValue() && isAllSelected()"
													  [indeterminate]="selection.hasValue() && !isAllSelected()">
										</mat-checkbox>
									</th>
									<td mat-cell *matCellDef="let row">
										<mat-checkbox (click)="$event.stopPropagation()"
													  (change)="$event ? selection.toggle(row) : null"
													  [checked]="selection.isSelected(row)">
										</mat-checkbox>
									</td>
								</ng-container>
								<ng-container *ngFor="let column of orderLinesTableColumnDefs"
											  [matColumnDef]="column.key">
									<th mat-header-cell
										*matHeaderCellDef
										mat-sort-header
										[arrowPosition]="column.className === 'align-right' ? 'before' : 'after'"
										class="{{ column.className }}">
										{{ column.heading | translate }}
									</th>
									<td mat-cell
										*matCellDef="let row"
										[title]="column.key === 'productId' ? '' : (column.displayValue ? column.displayValue(row) : row[column.key] || '')"
										class="{{ column.className }}"
										(mouseenter)="onCellMouseEnter(row, column.key, $event)"
										(mouseleave)="onCellMouseLeave(row, column.key, $event)">
										{{ column.displayValue ? column.displayValue(row) : row[column.key] }}
										<mat-icon
											*ngIf="column.key === ColumnKey.Status && row.isConfirmationDeadlineApproaching"
											class="confirm-deadline-approaching-table-icon"
											matTooltip="{{ 'ORDER_BASKET.CONFIRMATION_DEADLINE_WARNING.APPROACHING' | translate }}">
											access_time
										</mat-icon>
										<mat-icon
											*ngIf="column.key === ColumnKey.Status && row.isConfirmationDeadlinePassed"
											class="confirm-deadline-passed-table-icon"
											matTooltip="{{ 'ORDER_BASKET.CONFIRMATION_DEADLINE_WARNING.PASSED' | translate }}">
											notifications_active
										</mat-icon>
									</td>
								</ng-container>
								<tr mat-header-row *matHeaderRowDef="orderLinesTableDisplayedColumns"></tr>
								<tr mat-row
									*matRowDef="let row; columns: orderLinesTableDisplayedColumns; let i = index"
									[class.has-history]="orderLineHasHistory(i, row)"></tr>
								<ng-container matColumnDef="expandedDetail">
									<td mat-cell *matCellDef="let row"
										[attr.colspan]="orderLinesTableDisplayedColumns.length">
										<div *ngFor="let record of orderHistoryRecordsVMs.get(row.orderLineModel.id)"
											 class="order-line-history-record-container">
											<mat-icon>draw</mat-icon>
											<span>{{ record.historySubtypeKey | translate }}&nbsp;</span>
											<ng-container *ngIf="record.oldValue !== undefined">
												<span>{{ "ORDER_LINE.HISTORY.CHANGED_FROM" | translate }}&nbsp;</span>
												<span>{{ record.oldValue }}&nbsp;</span>
												<span>{{ "ORDER_LINE.HISTORY.TO" | translate }}&nbsp;</span>
											</ng-container>
											<span>{{ record.newValue }}</span>
										</div>
									</td>
								</ng-container>
								<tr mat-row
									*matRowDef="let row; columns: ['expandedDetail']; when: orderLineHasHistory.bind(this)"
									class="order-line-history-tr"></tr>
							</table>
					</div>
					<div class="order-lines-action-buttons-container button-container">
						<button mat-stroked-button [disabled]="!restriction.canAddOrderLine" (click)="addOrderLine()">{{ "ACTION_BUTTON_LABELS.ADD" | translate }}</button>
						<button mat-stroked-button [disabled]="!canModifyOrderLine" (click)="modifyOrderLine()">{{ "ACTION_BUTTON_LABELS.MODIFY" | translate }}</button>
						<button mat-stroked-button [disabled]="!canRemoveOrderLine" (click)="removeOrderLines()">{{ "ACTION_BUTTON_LABELS.REMOVE" | translate }}</button>
						<button mat-stroked-button [disabled]="!canChangeMaterial" (click)="changeMaterial()">{{ "ORDER_BASKET.ACTION_BUTTON_LABELS.CHANGE_MATERIAL" | translate }}</button>
					</div>
				</mat-card-content>
			</mat-card>
			<!--Material Panel-->
			<ng-container *ngIf="order && order.orderHeader && order.orderHeader.id">
				<cass-order-material-panel [order]="order"></cass-order-material-panel>
			</ng-container>
			<!--Action Buttons-->
			<mat-card class="branding--action-card button-container">
				<mat-card-content>
					<button mat-stroked-button *ngIf="orderHasAds && restriction.canSaveAsDraft && hasUnsavedChanges" (click)="saveDraftAsync()">{{ "ORDER_BASKET.ACTION_BUTTON_LABELS.SAVE_AS_DRAFT" | translate }}</button>
					<button mat-stroked-button *ngIf="orderHasAds && (restriction.canSaveAsDraft || hasUnsavedChanges || externalPlanInfo?.planId && !order.orderHeader.externalPlanId)" [disabled]="!canOrderBeReserved" (click)="reserveAsync()">{{ getReserveOrSaveButtonLabel() | translate }}</button>
					<button mat-stroked-button *ngIf="orderHasAds" [disabled]="!canOrderBeConfirmed" (click)="confirm()">{{ "ORDER_BASKET.ACTION_BUTTON_LABELS.CONFIRM" | translate }}</button>
					<button mat-stroked-button *ngIf="canOrderBeCancelled" (click)="cancel()">{{ "ORDER_BASKET.ACTION_BUTTON_LABELS.CANCEL" | translate }}</button>
					<button mat-stroked-button *ngIf="hasUnsavedChanges" (click)="discardChanges()">{{ "ACTION_BUTTON_LABELS.DISCARD_CHANGES" | translate }}</button>
					<cass-button-dropdown buttonLabel="{{ 'ORDER_BASKET.ACTION_BUTTON_LABELS.DOWNLOAD' | translate }}" [menuItems]="downloadButtonDropdownOptions"></cass-button-dropdown>
					<button mat-stroked-button [disabled]="!canAddOrderService" (click)="addService()">{{ "ORDER_BASKET.ACTION_BUTTON_LABELS.ADD_SERVICE" | translate }}</button>
					<button mat-stroked-button (click)="viewHistory()">{{ "ORDER_BASKET.ACTION_BUTTON_LABELS.VIEW_HISTORY" | translate }}</button>
				</mat-card-content>
			</mat-card>
		</div>
		<div class="chat-panel" *ngIf="order.orderHeader.id && isChatEnabled">
			<mat-card class="branding--title-card">
				<mat-card-content class="branding--title-card-content-box">
					<h1><mat-icon color="primary">question_answer</mat-icon>&nbsp;&nbsp;{{ "CHAT_MESSAGES.ORDER_CONVERSATIONS.CONVERSATION_PANEL_TITLE" | translate }}</h1>
				</mat-card-content>
			</mat-card>
			<app-order-conversations [orderId]="order.orderHeader.id" [showMessageId]="messageId"></app-order-conversations>
		</div>
	</div>
</div>
